<template>
  <div
    class="items signature-box"
    :name="selectData.elementCode"
    :data-path="selectData.elementPath"
  >
    <div class="items-wrap">
      <span class="lables">{{ selectData.elementName }}</span>
      <div class="from-right">
        <div class="t1">请于下方工整的签署您的姓名</div>
        <vue-esign
          class="canvas-write"
          ref="esign"
          :width="400"
          :height="200"
          :isCrop="isCrop"
          :lineWidth="lineWidth"
          :lineColor="lineColor"
          :bgColor.sync="bgColor"
        />
        <div class="write-btns">
          <button class="clear" @click="handleReset">清空画板</button>
          <button class="send" @click="handleGenerate">确认签名</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectData: {
      type: Object,
    },
  },
  data() {
    return {
      lineWidth: 3,
      lineColor: "#000000",
      bgColor: "",
      resultImg: "",
      isCrop: false,
      values: "",
    };
  },
  mounted() {
    if (this.selectData.elementValue) {
      this.values = this.selectData.elementValue;
    }
  },
  methods: {
    handleReset() {
      this.$refs.esign.reset();
    },
    handleGenerate() {
      this.$refs.esign
        .generate()
        .then((res) => {
          console.log(res);
          this.values = res;
          this.selectData.elementValue = res;
          this.$emit("selected", {
            type: 1,
            item: this.selectData,
            value: res,
          });
        })
        .catch((err) => {
          this.$notice.msg("您还没有签字！");
        });
    },
  },
  watch: {
    selectData(newVal) {
      this.values = newVal.elementValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.signature-box {
  .items-wrap {
      flex-direction: column !important;
      align-items: flex-start !important;
      .from-right{
          width: 100% !important;
      }
    .t1 {
      font-size: 28px;
      color: #666;
      line-height: 2;
      margin-bottom: 20px;
    }
    .canvas-write {
      border: 1px solid #eee;
    }
    .write-btns {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-top: 40px;
      button {
        width: 45%;
        height: 60px;
        border-radius: 30px;
        font-size: 32px;
         box-shadow: 0 0 3px 0 rgba(0, 132, 255, 0.5);
      }
      .clear {
        background-color: #fff;
        color: #666;
      }
      .send {
        background-color: #0084ff;
        color: #fff;
      }
    }
  }
}
</style>
